import {
  ManagerPermission,
  Permission,
} from "v2/domain/common/entities/ManagerPermission/ManagerPermission";
import authClient from "../../../../../app/auth/Auth";
import { apiInstance } from "../../api/apiClient";
import { GetManagerPermissionsResponse } from "../../types/GetManagerPermissionsResponse";

export const getUrl = ({ companyId }: { companyId: string }) => {
  return `/companies/v1/companies/${companyId}/me`;
};

const getManagerPermissions = async (): Promise<
  ManagerPermission | undefined
> => {
  const companyId = await authClient.getCompanyId();
  const url = getUrl({
    companyId: companyId ?? "",
  });

  const { data } = await apiInstance.get<GetManagerPermissionsResponse>(
    url,
    {}
  );

  return new ManagerPermission(data.content.permissions as Permission[]);
};

export default getManagerPermissions;
